<template>
	<section>
		<b-tabs v-model="tabselected" type="is-boxed" size="is-small">
			<b-tab-item label="Tudo" icon="clipboard-text-multiple-outline">
				<template slot="header">
					<feather class="feather-tabs" type="list" size="15" />
					<span class="content-tag-item">
						Tudo <b-tag rounded> {{ dataCountTotal }} </b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Faturado" icon="clipboard-text-multiple-outline">
				<template slot="header">
					<feather class="feather-tabs" type="save" size="15" />
					<span class="content-tag-item">
						Salvo
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[0] }}</h1></b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Salvo" icon="content-save-outline">
				<template slot="header">
					<feather class="feather-tabs" type="check-circle" size="15" />
					<span class="content-tag-item">
						Finalizado
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[1] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Finalizado" icon="check-circle-outline">
				<template slot="header">
					<feather class="feather-tabs" type="git-branch" size="15" />
					<span class="content-tag-item">
						Integrado
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[2] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Integrado" icon="cog">
				<template slot="header">
					<feather class="feather-tabs" type="alert-triangle" size="15" />
					<span class="content-tag-item">
						Inválido
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[3] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Inválido" icon="alert-circle-outline">
				<template slot="header">
					<feather class="feather-tabs" type="clock" size="15" />
					<span class="content-tag-item">
						Em Análise
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[4] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Em Análise" icon="clock-alert-outline">
				<template slot="header">
					<feather class="feather-tabs" type="check" size="15" />
					<span class="content-tag-item">
						Liberado
						<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[5] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Liberado" icon="text-box-check-outline">
				<template slot="header">
					<feather class="feather-tabs" type="clipboard" size="15" />
					<span class="content-tag-item">
						Faturado<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[6] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>
			<b-tab-item label="Cancelado" icon="close-octagon-outline">
				<template slot="header">
					<feather class="feather-tabs" type="x-circle" size="15" />
					<span class="content-tag-item">
						Cancelado<b-tag rounded>
							<h1 class="data-counters">{{ myCountData[7] }}</h1>
						</b-tag>
					</span>
				</template>
			</b-tab-item>

			<!--   <b-tab-item label="Deletado" icon="close-octagon-outline">
        <template slot="header">
          <feather class="feather-tabs" type="trash" size="15" />
          <span class="content-tag-item">
            Deletado
            <b-tag rounded>
              <h1 class="data-counters">{{ myCountData[8] }}</h1>
            </b-tag>
          </span>
        </template>
      </b-tab-item> -->
		</b-tabs>
		<customtable
			:data="pedidos"
			:is-loading="isLoading"
			:totalpages="total"
			:selectedguide="tabselected - 1"
			:currentpage="pagenumber"
			@restoreorder="restorOrder($event)"
			@pagechange="pageChange($event)"
			@pagelimit="pagelimit = $event"
			@reload="getPedidosFilter($event)"
			@selelectedCondition="getPedidosFilter((selelectedCondition = $event))"
			@search="getPedidosFilter($event)"
			@filter="getPedidosFilter($event)"
			@clearFilter="tabselected = -1"
		/>
	</section>
</template>

<script>
import customtable from '../../layout/components/table/customtable';
import * as ecAxios from '../../util/ecAxios';

export default {
	components: {
		customtable,
	},
	data() {
		return {
			logsituacaopedido: [],
			direction: 'asc',
			orderby: 'id',
			dataCountTotal: 0,
			tabselected: 0,
			limit: 10,
			offset: 0,
			pessoa_id: null,
			empresa_id: null,
			formpgto_id: null,
			searchTerm: null,
			situacao: null,
			situacoeslog: null,
			pedidos: [],
			isLoading: true,
			allCount: 0,
			clearFilter: false,
			total: 0,
			countData: [0, 0, 0, 0, 0, 0, 0, 0],
			countDataResponse: [],
			pagelimit: 50,
			pagenumber: 1,
			allDataStore: [],
			situacaoid: null,
			selelectedCondition: null,
			status: [
				{
					title: 'Salvo',
					total: 0,
					code: 0,
				},
				{
					title: 'Finalizado',
					total: 0,
					code: 1,
				},
				{
					title: 'Integrado',
					total: 0,
					code: 2,
				},
				{
					title: 'Inválido',
					total: 0,
					code: 3,
				},
				{
					title: 'Em análise',
					total: 0,
					code: 4,
				},
				{
					title: 'Liberado',
					total: 0,
					code: 5,
				},
				{
					title: 'Faturado',
					total: 0,
					code: 6,
				},
				{
					title: 'Cancelado',
					total: 0,
					code: 7,
				} /* 		{					title: 'Deletado',					total: 0,					code: 8,				}, */,
				{
					title: 'Aguardando Pagamento',
					total: 0,
					code: 10,
				},
			],
			selected: {},
			defaultFilterDate: {
				clienteCheckbox: false,
				direction: null,
				empresa_id: null,
				empresasCheckbox: false,
				fdateCheckbox: false,
				formpgto_id: null,
				fpagamentoCheckbox: false,
				inputDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
				inputFDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
				inputSitDateBetween: [{ dtsituacao_ini: '', dtsituacao_fin: '' }],
				sitdateCheckbox: false,
				sitDateSelect: 0,
				orderby: null,
				limit: 50,
				offset: 0,
				pessoa_id: null,
				situacoeslog: null,
				situationcheckbox: false,
				onlyDeleted: false,
				withDeleted: false,
			},
			showDetailIcon: true,
		};
	},
	computed: {
		mypedididos() {
			return this.pedidos;
		},
		mytotalPages() {
			return this.total;
		},
		myCountData() {
			return this.countData;
		},
	},
	watch: {
		tabselected(e) {
			const condition = e - 1;
			this.pagenumber = 1;
			if (condition < 0) {
				this.situacao = null;
				const filters = JSON.parse(localStorage.getItem('filters'));
				if (filters) {
					filters.situacao = null;
					localStorage.setItem('filters', JSON.stringify(filters));
				} else {
					const filterDate = {
						...this.defaultFilterDate,
						situacao: this.situacao,
					};
					localStorage.setItem('filters', JSON.stringify(filterDate));
				}
				this.getPedidosFilter();
			} else {
				this.situacao = [condition];
				this.getPedidosFilter({ situacao: this.situacao });

				const filters = JSON.parse(localStorage.getItem('filters'));

				if (filters) {
					filters.situacao = this.situacao;
					localStorage.setItem('filters', JSON.stringify(filters));
				} else {
					const filterDate = {
						...this.defaultFilterDate,
						situacao: this.situacao,
					};
					localStorage.setItem('filters', JSON.stringify(filterDate));
				}
			}
		},
	},
	methods: {
		async restorOrder(orderId) {
			try {
				const url = `${process.env.VUE_APP_API_ADM_EC + api.env.EC_PEDIDOS_RESTAURAR + orderId}`;
				const response = await ecAxios.connection().post(url);
				const { data } = response;
				if (data.error !== 1) {
					this.$buefy.notification.open({
						message: `Pedido ${orderId} restaurado com sucesso!, seu novo id é ${data.pedido.id}.`,
						type: 'is-success',
					});
					const filters = JSON.parse(localStorage.getItem('filters')) || null;
					this.getPedidosFilter(filters);
				} else {
					throw new Error(data.message);
				}
			} catch (err) {
				this.$buefy.notification.open({ message: err.message.toString(), type: 'is-danger' });
			}
		},
		pageChange(filters) {
			this.getPedidosFilter({
				...filters,
			});
			this.pagenumber = filters.pagenumber;
		},
		toggle(row) {
			this.$refs.table.toggleDetails(row);
		},
		showContext(row, context) {
			this.selected = row;
			context.preventDefault();
			this.$refs.menu.open(context, row);
		},
		clearDataFilter() {
			this.situacao = null;
			this.situacoeslog = null;
			this.pessoa_id = null;
			this.empresa_id = null;
			this.formpgto_id = null;
			this.searchTerm = '';
		},
		async countSituacoes(data, dateSitLog) {
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDOS}`, data)
				.then((response) => {
					if (response.status === 200) {
						let saveCounter = 0;
						let finishCounter = 0;
						let integratedCounter = 0;
						let invalidCounter = 0;
						let inanalysisCounter = 0;
						let releasedCounter = 0;
						let billedCounter = 0;
						let canceledCounter = 0;
						let deletedCounter = 0;

						let situationArrayF = [];
						if (response.data.countSituacoes.length >= 0) {
							response.data.countSituacoes.map((item) => {
								switch (item.situacao) {
									case 0:
										saveCounter += item.qtd;
										break;
									case 1:
										finishCounter += item.qtd;
										break;
									case 2:
										integratedCounter += item.qtd;
										break;
									case 3:
										invalidCounter += item.qtd;
										break;
									case 4:
										inanalysisCounter += item.qtd;
										break;
									case 5:
										releasedCounter += item.qtd;
										break;
									case 6:
										billedCounter += item.qtd;
										break;
									case 7:
										canceledCounter += item.qtd;
										break;
									case 8:
										deletedCounter += item.qtd;
										break;

									default:
										break;
								}
								situationArrayF = [
									saveCounter,
									finishCounter,
									integratedCounter,
									invalidCounter,
									inanalysisCounter,
									releasedCounter,
									billedCounter,
									canceledCounter,
									deletedCounter,
								];
								return this.countData;
							});
						}
						if (dateSitLog !== null && dateSitLog.length === 1) {
							if (this.pedidos.length === 0) {
								this.countData[dateSitLog] = 0;
							} else {
								this.countData[dateSitLog] = 0; // It's necessary?
								this.countData[dateSitLog] = situationArrayF[dateSitLog];
							}
						} else {
							this.countData = [
								saveCounter,
								finishCounter,
								integratedCounter,
								invalidCounter,
								inanalysisCounter,
								releasedCounter,
								billedCounter,
								canceledCounter,
								deletedCounter,
							];
						}
						const ctBkp = this.countData;
						this.countData = [];
						this.countData = ctBkp;
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
		async getPedidosFilter(data = null) {
			this.isLoading = true;
			// Limpar variaveis
			this.empresa_id = null;
			this.formpgto_id = null;
			this.searchTerm = null;
			this.situacao = null;
			this.situacoeslog = null;
			this.pessoa_id = null;
			this.orderby = 'id';
			this.direction = 'desc';
			let onlyDeleted = false;
			let withDeleted = false;
			let onlyInTrash = false;
			if (data) {
				if (data.pessoa_id) {
					this.pessoa_id = data.pessoa_id;
				}
				if (data.empresa_id) {
					this.empresa_id = data.empresa_id;
				}
				if (data.formpgto_id && data.formpgto_id > 0) {
					this.formpgto_id = data.formpgto_id;
				}
				if (data.searchTerm) {
					this.searchTerm = data.searchTerm;
				}
				if (data.situacao && data.situacao.length > 0) {
					this.situacao = data.situacao;
				}
				if (data.situacoeslog) {
					this.situacoeslog = data.situacoeslog;
				}
				if (data.limit) {
					this.limit = data.limit;
				}
				if (data.offset === 0) {
					this.offset = data.offset;
				}
				if (data.pagenumber) {
					this.pagenumber = data.pagenumber;
				}
				if (data.orderby) {
					this.orderby = data.orderby;
				}
				if (data.direction) {
					this.direction = data.direction;
				}
				if (data.statusdata && data.statusdata === 2) {
					onlyInTrash = true;
				}
				if (data.statusdata && data.statusdata === 1) {
					onlyDeleted = true;
				}
				if (data.withDeleted) {
					withDeleted = true;
				}
			}

			this.limit = this.pagelimit;
			this.offset = this.pagenumber * this.pagelimit - this.pagelimit;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_PEDIDOS}`, {
					limit: this.limit,
					offset: this.offset,
					pessoa_id: this.pessoa_id,
					empresa_id: this.empresa_id,
					formpgto_id: this.formpgto_id,
					searchTerm: this.searchTerm,
					situacao: this.situacao,
					situacoeslog: this.situacoeslog,
					orderby: this.orderby,
					direction: this.direction,
					only_in_trash: onlyInTrash,
					only_deleted: onlyDeleted,
					with_deleted: withDeleted,
					busca_valores: true,
				})
				.then((response) => {
					if (response.status === 200) {
						if (!onlyDeleted) {
							const dateSitLog = {
								pessoa_id: this.pessoa_id,
								empresa_id: this.empresa_id,
								formpgto_id: this.formpgto_id,
								situacao: this.situacao,
								situacoeslog: this.situacoeslog,
								countSituacoes: true,
								only_deleted: onlyDeleted,
								with_deleted: withDeleted,
							};

							this.countSituacoes(dateSitLog, this.situacao);
						} else {
							this.countData[8] = response.data.count;
						}
						this.pedidos = [];
						const { pedidos } = response.data;
						this.total = response.data.count;
						this.dataCountTotal = response.data.count;
						this.pedidos = pedidos;
						this.isLoading = false;
					} else if (response.data.error !== 0) {
						throw new Error(response.data.message);
					}
				})
				.catch((e) => {
					this.$buefy.notification.open({
						message: e,
						type: 'is-danger',
					});
					this.pedidos = [];
					this.isLoading = false;
				});
		},
	},
};
</script>
<style scoped>
.data-counters {
	font-size: 10px;
}
.feather-tabs {
	margin-right: 4px;
}
.container-box-headers {
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
	height: 80px;
}
.container-table {
	border-left: 1px solid #dbdbdb;
	border-right: 1px solid #dbdbdb;
	border-bottom: 1px solid #dbdbdb;
}

.abas-pedidos {
	width: 100%;
	display: flex;
	flex-direction: column;
}
.title-counter-container {
	width: 100%;
	padding-right: 10px;
	padding-top: 10px;
	padding-bottom: 10px;
	margin-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.title-counter-container h1 {
	font-size: 16px;
	color: #25213b;
}

.pedidos-tag {
	display: flex;
	width: 100%;
	justify-content: space-between;
}

.search-container {
	margin-left: 10px;
}
.table-filters {
	width: 100%;
	background-color: #fff;
	display: flex;
	align-items: center;
	padding-right: 10px;
	justify-content: space-between;
}
.menu-row-icon {
	color: #8b83ba;
	padding-left: 10px;
	padding-right: 10px;
	font-weight: 500;
}

.menu-row-box-bottom {
	padding-top: 10px;
}
.menu-row-box {
	padding-bottom: 10px;
	border-bottom: 1px solid #f2f0f9;
}
.menu-row-option:hover {
	background-color: #f2f0f9 !important;
	color: #25213b !important;
	border-radius: 5px;
}

.menu-row-option:hover .danger {
	color: #dc3545 !important;
}

.menu-row-option:hover .check {
	color: #007f00;
}

.menu-row-option:hover .archive {
	color: #f77f00;
}

.menu-row-option {
	display: flex;
	align-items: center;
	margin-left: 5px;
	margin-right: 5px;
	padding: 10px;

	cursor: pointer;
}
.table-title {
	color: #25213b;
	font-weight: 500;
	margin-top: 2.5px;
	margin-bottom: 2px;
}

.status {
	display: flex;
	align-items: center;
	background-color: #cdffcd;
	border-radius: 8px;
	padding: 2px;
	justify-content: center;
	font-size: 12px;
	color: #007f00;
	max-width: 55px;
	cursor: pointer;
}
.circle {
	display: flex;
	width: 6px;
	height: 6px;
	margin-right: 5px;
	background-color: #007f00;
	border-radius: 50%;
}
.table-subtitle {
	font-size: 10.5px;
	margin-bottom: 2.5px;
	font-weight: 400;
	color: #6e6893;
}
.view-more-link {
	text-decoration: none;
}
.view-more-link h1 {
	padding-top: 5px;
	padding-bottom: 5px;
	color: #6e6893;
	font-size: 11px;
	border-radius: 2px;
	transition: 0.2s ease-in-out;
}
.view-more-link h1:hover {
	color: #5a5577;
	background-color: #7e6ee457;
}
.content-tag-item {
	display: flex;
	align-items: center;
	justify-content: center;
}

.dots {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	cursor: pointer;
	transition: 0.5s ease-in-out;
}
.dots:hover span {
	background-color: #574d8b;
}

.dots span {
	display: flex;
	width: 3px;
	height: 3px;
	border-radius: 50%;
	margin: 1px;
	background-color: #8b83ba;
}
</style>

